<template>
  <div class="edit-wrap">
    <!-- 投放内容 -->
    <div class="item-card">
      <div class="card-title">投放内容</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="tfContent" :rules="rules" ref="tfcontentRef">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">广告名称：</span>
              <div class="form-value">
                <el-form-item prop="ad_name" style="margin-bottom: 0px">
                  <el-input v-model="tfContent.ad_name" placeholder="(必填)请输入广告名称"></el-input>
                </el-form-item>
                <ul class="name-list">
                  <li
                    v-for="(item, index) of showAdList"
                    :key="index"
                    :class="['name-item', selectItem.indexOf(index) === -1 ? '' : 'cur']"
                    @click="handleSelectItem(item, index)"
                  >
                    {{ item }}
                  </li>
                  <li class="show-more">
                    <span v-show="!showMore" @click="showMore = true">更多<i class="el-icon-arrow-down"></i></span>
                    <span v-show="showMore" @click="showMore = false">收起<i class="el-icon-arrow-up"></i></span>
                  </li>
                </ul>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">下载方式：</span>
              <div class="form-value">
                <el-radio-group :disabled="!!alreadyProjectId" v-model="tfContent.download_type">
                  <el-radio label="DOWNLOAD_URL">直接下载</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">投放目标：</span>
              <div class="form-value">
                <el-radio-group :disabled="!!alreadyProjectId" v-model="tfContent.delivery_purpose">
                  <el-radio label="CONVERT">转化量</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">优化目标：</span>
              <div class="form-value">
                <el-form-item prop="external_action" style="margin-bottom: 0px">
                  <el-select
                    :disabled="!!alreadyProjectId"
                    v-model="tfContent.external_action"
                    placeholder="(必填)请选择"
                    @change="(val) => changeTarget(val, true)"
                  >
                    <el-option
                      v-for="item of converDataList"
                      :key="item.externalAction"
                      :label="item.optimization_name"
                      :value="item.externalAction"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">深度优化目标：</span>
              <div class="form-value">
                <el-form-item prop="deep_external_action" style="margin-bottom: 0px">
                  <el-select
                    :disabled="!!alreadyProjectId"
                    v-if="deliverySetting && deliverySetting.bid_type === 'NO_BID'"
                    v-model="tfContent.deep_external_action"
                    placeholder="(必填)请选择"
                  >
                    <el-option label="无" value="NONE"></el-option>
                  </el-select>
                  <el-select :disabled="!!alreadyProjectId" v-else v-model="tfContent.deep_external_action" placeholder="(必填)请选择">
                    <el-option label="无" value="NONE"></el-option>
                    <el-option
                      v-for="item of deepConverList"
                      :key="item.deepExternalAction"
                      :label="item.optimizationName"
                      :value="item.deepExternalAction"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
            <li class="form-item" v-if="tfContent.deep_external_action && tfContent.deep_external_action !== 'NONE'">
              <span class="form-label" style="padding-top: 0px">深度优化方式：</span>
              <div class="form-value">
                <el-radio-group v-model="tfContent.deep_bid_type">
                  <el-radio label="DEEP_BID_MIN">自定义手动出价</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require" style="padding-top: 6px">应用包名：</span>
              <div class="form-value">
                <el-form-item prop="package_name" style="margin-bottom: 0px">
                  <el-input
                    style="width: 255px"
                    v-model="tfContent.package_name"
                    :disabled="true"
                    placeholder="选择应用自动填充"
                  ></el-input>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 引用已有广告 -->
    <div class="item-card">
      <div class="card-title">引用已有广告</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form>
            <li class="form-item">
              <span class="form-label" style="padding-top: 6px">引用已有广告：</span>
              <div class="form-value">
                <el-form-item style="margin-bottom: 0px">
                  <el-button size="mini" type="primary" @click="showReferenceAlreadyAdModal">选择广告</el-button>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 推广身份 -->
    <div class="item-card">
      <div class="card-title">推广身份</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="nativeSetting" :rules="nativeSettingRules" ref="nativeSettingRef">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 0px">推广身份：</span>
              <div class="form-value">
                <el-radio-group v-model="nativeSetting.identityType">
                  <el-radio label="TIKTOK">抖音号</el-radio>
                  <el-radio label="ACCOUNT">账户信息</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-if="nativeSetting.identityType === 'TIKTOK'">
              <span class="form-label require" style="padding-top: 6px">抖音号：</span>
              <div class="form-value">
                <el-form-item prop="aweme_id" style="margin-bottom: 0px">
                  <el-select v-model="nativeSetting.aweme_id" filterable placeholder="(必填)请选择推广抖音号">
                    <el-option
                      v-for="item of awemeDataList"
                      :key="item.aweme_id"
                      :label="item.aweme_name"
                      :value="item.aweme_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 原生锚点 -->
    <div class="item-card" v-if="nativeSetting.identityType === 'TIKTOK'">
      <div class="card-title">原生锚点</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="nativeSetting" :rules="nativeSettingRules" ref="nativeAnchorRef">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 0px">原生锚点：</span>
              <div class="form-value">
                <el-radio-group v-model="nativeSetting.anchor_related_type">
                  <el-radio label="OFF">不启用</el-radio>
                  <el-radio label="AUTO">自动生成</el-radio>
                  <el-radio label="SELECT">手动选择</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-if="nativeSetting.anchor_related_type === 'SELECT'">
              <span class="form-label require" style="padding-top: 6px">选择锚点：</span>
              <div class="form-value">
                <el-form-item prop="anchor_id" style="margin-bottom: 0px">
                  <el-select v-model="nativeSetting.anchor_id" filterable placeholder="请选择锚点">
                    <el-option
                      v-for="item of anchorDataList"
                      :key="item.anchor_id"
                      :label="item.anchor_name"
                      :value="item.anchor_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 产品信息 -->
    <div class="item-card">
      <div class="card-title">产品信息</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="productInfo" :rules="productInfoRules" ref="productInfoRef">
            <li class="form-item">
              <span class="form-label require">产品名称：</span>
              <div class="form-value">
                <el-form-item prop="title">
                  <el-input
                    v-model="productInfo.title"
                    placeholder="请输入产品名称"
                    maxlength="20"
                    minlength="1"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require">产品主图：</span>
              <div class="form-value">
                <div style="font-size: 12px; margin: 4px 0px 10px 0px; color: #999">
                  已添加：{{ productInfo.imageList.length }} / 10
                  <span style="color: #1890ff; margin-left: 8px">请选择108*108尺寸的素材</span>
                </div>
                <el-form-item prop="imageList">
                  <div class="imgs-list">
                    <div class="add-material" v-for="item in productInfo.imageList" :key="item.toutiaoId">
                      <div class="img-wrap">
                        <i class="el-icon-close" @click="deleteImage(item)"></i>
                        <img class="materialI-img" :src="item.path || ''" alt="" />
                      </div>
                    </div>
                    <div class="add-wrap" v-show="productInfo.imageList.length < 10" @click="showMaterialModal">
                      <i class="el-icon-plus add-icon"></i>
                      <span class="add-text">上传照片</span>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require">产品卖点：</span>
              <div class="form-value">
                <div class="md-wrap">
                  <div class="md-item">
                    <el-input style="width: 400px" placeholder="6-9个字符，英文、数字算0.5个字符，中文1个字符" v-model="inputRecommed">
                      <template slot="append">
                        <el-button
                          :disabled="!isCanAddRecommend"
                          @click="addRecommend"
                          class="recommend-btn"
                          :class="{ 'recommend-btn-disabled': !isCanAddRecommend }"
                          >添加</el-button
                        >
                      </template>
                    </el-input>
                    <span class="view-recommend" @click="showRecommendProductPoint('recommend')">查看推荐</span>
                    <el-form-item prop="selling_points" style="margin-bottom: 0px">
                      <div class="point-list">
                        <div class="point-list-top">
                          <div style="margin-left: 16px">已选（{{ productInfo.selling_points.length }}/10）</div>
                          <div class="clear-btn" @click="clearSellPoints('recommend')">清空</div>
                        </div>
                        <div class="point-list-content" v-if="productInfo.selling_points.length > 0">
                          <span v-for="(item, index) in productInfo.selling_points" :key="index" class="point-item">
                            <span class="el-tag el-tag--info el-tag--small el-tag--light">
                              <span class="el-select__tags-text"> {{ item }}</span>
                              <i class="el-tag__close el-icon-close" @click="deletePoints('recommend', index)"></i>
                            </span>
                          </span>
                        </div>
                        <div v-else class="point-list-nodata">暂无产品卖点，请添加</div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label require">行动号召：</span>
              <div class="form-value">
                <div class="md-wrap">
                  <div class="md-item">
                    <el-input style="width: 400px" placeholder="2-6个字符，英文、数字算0.5个字符，中文1个字符" v-model="inputCallAction">
                      <template slot="append">
                        <el-button
                          :disabled="!isCanAddCallAction"
                          @click="addCallAction"
                          class="recommend-btn"
                          :class="{ 'recommend-btn-disabled': !isCanAddCallAction }"
                          >添加</el-button
                        >
                      </template>
                    </el-input>
                    <span class="view-recommend" @click="showRecommendProductPoint('callAction')">查看推荐</span>
                    <el-form-item prop="call_to_action_buttons" style="margin-bottom: 0px">
                      <div class="point-list">
                        <div class="point-list-top">
                          <div style="margin-left: 16px">已选（{{ productInfo.call_to_action_buttons.length }}/10）</div>
                          <div class="clear-btn" @click="clearSellPoints('callAction')">清空</div>
                        </div>
                        <div class="point-list-content" v-if="productInfo.call_to_action_buttons.length > 0">
                          <span v-for="(item, index) in productInfo.call_to_action_buttons" :key="index" class="point-item">
                            <span class="el-tag el-tag--info el-tag--small el-tag--light">
                              <span class="el-select__tags-text"> {{ item }}</span>
                              <i class="el-tag__close el-icon-close" @click="deletePoints('callAction', index)"></i>
                            </span>
                          </span>
                        </div>
                        <div v-else class="point-list-nodata">暂无行动号召，请添加</div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 关联产品投放 -->
    <div class="item-card">
      <div class="card-title">关联产品投放</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="relatedProduct" :disabled="!!alreadyProjectId" :rules="relatedProductRules" ref="relatedProductRef">
            <li class="form-item">
              <span class="form-label require" style="padding-top: 10px">关联产品：</span>
              <div class="form-value">
                <el-form-item prop="productId">
                  <el-radio-group v-model="relatedProduct.productSetting">
                    <el-radio label="NO_MAP">不启用</el-radio>
                    <el-radio label="SINGLE">启用</el-radio>
                  </el-radio-group>
                  <div style="margin-top: 18px" v-if="relatedProduct.productSetting === 'SINGLE'">
                    <el-button size="mini" type="primary" @click="chooseProduct" v-if="relatedProduct.productTableData.length == 0">
                      选择产品
                    </el-button>
                    <el-table v-else :data="relatedProduct.productTableData" style="width: 100%">
                      <el-table-column prop="product_id" label="产品ID"></el-table-column>
                      <el-table-column prop="name" label="产品名称"> </el-table-column>
                      <el-table-column label="操作" width="100">
                        <template>
                          <el-button type="text" size="small" @click="chooseProduct">更换</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 投放位置 -->
    <div class="item-card">
      <div class="card-title">投放位置</div>
      <div class="card-content">
        <ul class="modal-form">
          <el-form :model="deliveryRange" :disabled="!!alreadyProjectId" :rules="deliveryRangeRules" ref="deliveryRangeRef">
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">投放范围：</span>
              <div class="form-value">
                <el-radio-group v-model="deliveryRange.inventory_catalog">
                  <el-radio label="UNIVERSAL_SMART">通投智选</el-radio>
                  <el-radio label="MANUAL">首选媒体</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-if="deliveryRange.inventory_catalog === 'MANUAL'">
              <span class="form-label" style="padding-top: 11px">广告位置：</span>
              <div class="form-value">
                <el-form-item prop="inventory_type" style="margin-bottom: 0px">
                  <el-dropdown trigger="click" :hide-on-click="false">
                    <span> 按媒体指定位置<i style="margin-left: 6px" class="el-icon-arrow-down"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-checkbox-group class="my-dropdown-select" v-model="deliveryRange.inventory_type" @change="changeInventoryType">
                        <el-checkbox v-for="item in inventory_type_list" :key="item.value" :label="item.value">
                          <div class="my-dropdown-select-item">
                            <img class="img" :src="getImgUrl(item.icon)" />
                            <span class="label">{{ item.label }}</span>
                          </div>
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
              </div>
            </li>
            <li
              class="form-item"
              v-if="
                deliveryRange.inventory_catalog === 'MANUAL' &&
                deliveryRange.inventory_type.length === 1 &&
                deliveryRange.inventory_type[0] === 'INVENTORY_UNION_SLOT'
              "
            >
              <span class="form-label" style="padding-top: 0px">投放形式：</span>
              <div class="form-value">
                <el-radio-group v-model="deliveryRange.union_video_type">
                  <el-radio label="REWARDED_VIDEO">激励视频</el-radio>
                  <el-radio label="ORIGINAL_VIDEO">原生视频</el-radio>
                  <el-radio label="SPLASH_VIDEO">开屏视频</el-radio>
                </el-radio-group>
              </div>
            </li>
            <!-- 搜索快投 -->
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">搜索快投：</span>
              <div class="form-value">
                <el-radio-group v-model="deliveryRange.searchToLaunch">
                  <el-radio
                    :label="1"
                    :disabled="
                      deliveryRange.delivery_range === 'UNION' ||
                      (deliveryRange.inventory_type[0] === 'INVENTORY_UNION_SLOT' && deliveryRange.inventory_type.length === 1)
                    "
                    >启用</el-radio
                  >
                  <el-radio :label="0">不启用</el-radio>
                </el-radio-group>
                <div class="search-wrap" v-show="deliveryRange.searchToLaunch === 1">
                  <div class="top-header">
                    <div class="cell-left">已选择关键词({{ wordsList.length }}/1000)</div>
                    <div class="cell-right">
                      <span class="btn-icon" @click="batchAdd">批量添加</span>
                      <span class="btn-icon" @click="wordsList = []">清空</span>
                    </div>
                  </div>
                  <div class="table-header">
                    <div class="cell-left">关键词</div>
                    <div class="cell-right">匹配方式</div>
                  </div>
                  <div class="table-content">
                    <div class="table-row" v-for="(item, index) of wordsList" :key="index">
                      <div class="cell-left">{{ item.keyword }}</div>
                      <div class="cell-right">
                        {{
                          item.match_type === "PHRASE"
                            ? "短语"
                            : item.match_type === "EXTENSIVE"
                            ? "广泛"
                            : item.match_type === "PRECISION"
                            ? "精确"
                            : "-"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li
              class="form-item"
              v-if="
                deliverySetting &&
                deliverySetting.bid_type !== 'NO_BID' &&
                tfContent.deep_external_action === 'NONE' &&
                deliveryRange.searchToLaunch === 1
              "
            >
              <span class="form-label require" style="padding-top: 6px">出价系数：</span>
              <div class="form-value">
                <el-form-item prop="search_bid_ratio" style="margin-bottom: 0px">
                  <el-input style="width: 400px" v-model="deliveryRange.search_bid_ratio" placeholder="请输入出价系数"></el-input>
                </el-form-item>
                <div style="font-size: 14px; color: #999; margin-top: 12px">
                  推荐出价系数 {{ recommendBid }}
                  <span style="color: #409eff; cursor: pointer; margin-left: 6px" @click="handleAccept">立即采纳</span>
                </div>
              </div>
            </li>
            <li class="form-item" v-if="deliveryRange.searchToLaunch === 1">
              <span class="form-label" style="padding-top: 0px">定向扩展：</span>
              <div class="form-value">
                <el-radio-group v-model="deliveryRange.audience_extend">
                  <el-radio label="ON">启用</el-radio>
                  <el-radio label="OFF">不启用</el-radio>
                </el-radio-group>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
    </div>
    <!-- 关联产品投放弹窗 -->
    <related-product-modal ref="relatedProductModalRef" @selectOk="chooseRelateProduct"></related-product-modal>
    <!-- 引用已有广告弹窗 -->
    <reference-already-ad-modal ref="referenceAlreadyAdModalRef" @selectOk="choosePromotion"></reference-already-ad-modal>
    <!-- 人群包 -->
    <rqb ref="rqbRef"></rqb>
    <!-- 落地页 -->
    <ldy ref="ldyRef"></ldy>
    <!-- 搜索快投弹框 -->
    <quick-launch ref="quickLaunchRef" @selectOk="selectOk"></quick-launch>
    <!-- 素材选择弹框 -->
    <material-modal ref="materialModalRef" width="108" height="108" selectType="image" @selectOk="selectedMaterial"></material-modal>
    <!-- 产品卖点, 行动号召推荐弹框 -->
    <product-point-modal ref="productPointModalRef" @selectOk="chooseProductRecommend"></product-point-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MaterialModal from "./subBaseset/sub/materialModal.vue";
import RelatedProductModal from "./subBaseset/sub/relatedProductModal.vue";
import ReferenceAlreadyAdModal from "./subBaseset/sub/referenceAlreadyAdModal.vue";
import ProductPointModal from "./subBaseset/sub/productPointModal.vue";
import Rqb from "./subBaseset/rqb.vue";
import Ldy from "./subBaseset/ldy.vue";
import nameTransforUtil from "./common/nameTransforUtil.js";
import QuickLaunch from "./subBaseset/quickLaunchModal.vue";
import { feedAds, optimizedGoal, searchBid_ttV2, getAwemeAuthList_ttV2, getNativeAnchor_ttV2 } from "@/api/promotion.js";
import { inventory_type_list } from "./subDirectpkg/optionData";
export default {
  components: {
    Rqb,
    Ldy,
    QuickLaunch,
    MaterialModal,
    RelatedProductModal,
    ProductPointModal,
    ReferenceAlreadyAdModal,
  },
  data() {
    return {
      showMore: false,
      inventory_type_list,
      selectItem: [],
      adGroupList: [
        "投放范围",
        "广告位置",
        "投放形式",
        "下载方式",
        "创意分类",
        "开始时间",
        "创意组名称",
        "落地页",
        "投放方式",
        "试玩素材",
        "转化名称",
        "定向包",
        "标题包",
        "预算与出价",
        "创建日期",
        "首个视频名称",
        "首个图片名称",
        "账户备注名",
        "玩法名称",
        "素材日期",
      ],
      tfContent: {
        ad_name: "",
        download_type: "DOWNLOAD_URL",
        delivery_purpose: "CONVERT",
        deep_bid_type: "DEEP_BID_MIN",
        external_action: "",
        deep_external_action: "NONE",
        package_name: "",
        app_type: "",
      },
      // 推广身份
      nativeSetting: {
        identityType: "TIKTOK",
        aweme_id: "",
        anchor_related_type: "OFF",
        anchor_id: "",
      },
      nativeSettingRules: {
        aweme_id: [
          {
            required: true,
            message: "请选择推广抖音号",
            trigger: ["blur", "change"],
          },
        ],
        anchor_id: [
          {
            required: true,
            message: "请选择锚点",
            trigger: ["blur", "change"],
          },
        ],
      },
      // 产品信息
      productInfo: {
        title: "",
        imageList: [],
        image_ids: [],
        selling_points: [],
        call_to_action_buttons: [],
      },
      inputRecommed: "",
      inputCallAction: "",
      productInfoRules: {
        title: [
          {
            required: true,
            message: "请输入产品名称",
            trigger: ["blur", "change"],
          },
        ],
        imageList: [
          {
            validator: (rule, value, callback) => {
              if (this.productInfo.imageList.length === 0) {
                callback(new Error("请上传产品主图"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        selling_points: [
          {
            validator: (rule, value, callback) => {
              if (this.productInfo.selling_points.length === 0) {
                callback(new Error("产品卖点不能为空"));
              } else if (this.productInfo.selling_points.length > 10) {
                callback(new Error("产品卖点最大长度为10个"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        call_to_action_buttons: [
          {
            validator: (rule, value, callback) => {
              if (this.productInfo.call_to_action_buttons.length === 0) {
                callback(new Error("行动号召不能为空"));
              } else if (this.productInfo.call_to_action_buttons.length > 10) {
                callback(new Error("行动号召最大长度为10个"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      // 关联产品投放
      relatedProduct: {
        productSetting: "NO_MAP",
        productTableData: [],
        productId: "",
        productPlatformId: "",
      },
      relatedProductRules: {
        productId: [
          {
            validator: (rule, value, callback) => {
              if (this.relatedProduct.productSetting === "SINGLE" && this.relatedProduct.productTableData.length === 0) {
                callback(new Error("请选择关联产品"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      // 投放位置
      deliveryRange: {
        inventory_catalog: "MANUAL",
        inventory_type: [],
        union_video_type: "REWARDED_VIDEO",
        //是否开启搜索快投
        searchToLaunch: 1,
        search_bid_ratio: "",
        audience_extend: "ON",
      },
      allOptions: [],
      rules: {
        ad_name: [
          {
            required: true,
            message: "请输入广告计划名称",
            trigger: ["blur", "change"],
          },
        ],
        external_action: [
          {
            required: true,
            message: "请选择转化目标",
            trigger: ["change"],
          },
        ],
        deep_external_action: [
          {
            required: true,
            message: "请选择深度转化目标",
            trigger: ["change"],
          },
        ],
        package_name: [
          {
            required: true,
            message: "请输入应用包名",
            trigger: ["blur", "change"],
          },
        ],
      },
      deliveryRangeRules: {
        inventory_type: [
          {
            validator: (rule, value, callback) => {
              if (value === "MANUAL" && this.deliveryRange.inventory_type.length === 0) {
                callback(new Error("请勾选媒体指定位置"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        search_bid_ratio: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("出价系数不能为空"));
              } else if (value < 1 || value > 2 || !/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/.test(value)) {
                callback(new Error("出价系数为1~2的数字，且最多两位小数"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      wordsList: [],
      converDataList: [], //转化相关数据
      deepConverList: [], //深度转化目标
      awemeDataList: [], // 推广抖音号
      anchorDataList: [], // 锚点
      recommendBid: "",
    };
  },
  methods: {
    //弹框出现时查询表单数据(父组件调用),表单渲染
    initFormData() {
      this.initData();
      this.renderData();
      this.$refs.rqbRef.getListOption();
      this.$refs.ldyRef.initOptions();
    },
    // 判断字符长度，字母数字算半个，中文算一个
    getStringLength(str) {
      let strLength = 0;
      const chinese = "[\u4e00-\u9fa5]";
      for (var i = 0; i < str.length; i++) {
        // 获取一个字符
        let temp = str.substring(i, i + 1);
        // 判断是否为中文字符
        if (temp.match(chinese)) {
          // 中文字符长度为1
          strLength += 1;
        } else {
          strLength += 0.5;
        }
      }
      return strLength;
    },
    initData() {
      //查询转化和深度转化
      if (this.converDataList.length === 0) {
        optimizedGoal({
          advertiserId: this.adCount,
          appType: this.app_type.replace("APP_", ""),
          pkg: this.app_pkg,
        }).then((res) => {
          if (res.code === "0000") {
            this.converDataList = res.optimizedGoalList;
            if (this.tfContent.external_action) {
              this.changeTarget(this.tfContent.external_action, false);
            }
          }
        });
      }
      // 查询推广抖音号
      getAwemeAuthList_ttV2({ advertiserId: this.adCount }).then((res) => {
        this.awemeDataList = res.data;
      });
      // 查询锚点
      getNativeAnchor_ttV2({
        advertiserId: this.adCount,
        osType: this.checkedApp?.app_type === "ANDROID" ? "android" : "ios",
        pkg: this.checkedApp?.package_name,
      }).then((res) => {
        this.anchorDataList = res.data;
      });
      //查询搜索快投的数据
      this.$nextTick(() => {
        if (this.wordsList.length === 0) {
          let advertiserIdList = this.adCount;
          feedAds({
            advertiserId: advertiserIdList,
          }).then((res) => {
            if (res.code === "0000") {
              let resList = res.feedAdsList;
              this.wordsList = resList;
            }
          });
        }
      });
      // 获取推荐出价系数
      searchBid_ttV2({
        advertiserId: this.adCount,
      }).then((res) => {
        this.recommendBid = res.data;
      });
    },
    getImgUrl(src) {
      return require(`./static/${src}.png`);
    },
    changeTarget(val, clear) {
      let curData = this.converDataList.find((item) => item.externalAction === val);
      if (curData) {
        this.deepConverList = curData.optimizedDeepGoalList;
      }
      if (clear) {
        this.tfContent.deep_external_action = "NONE";
      }
    },
    //搜索快投
    batchAdd() {
      this.$refs.quickLaunchRef.showModal();
    },
    changeInventoryType() {
      if (this.deliveryRange.inventory_type[0] === "INVENTORY_UNION_SLOT" && this.deliveryRange.inventory_type.length === 1) {
        this.deliveryRange.searchToLaunch = 0;
      }
    },
    //弹框关闭保存数据到store(父组件调用)
    saveDataInStore() {
      this.saveInStore();
      this.$refs.rqbRef.saveInStore();
      this.$refs.ldyRef.saveInStore();
    },
    //弹框关闭时校验数据格式
    checkData() {
      return Promise.all([this.checkCurData(), this.$refs.rqbRef.checkData(), this.$refs.ldyRef.checkData()]);
    },
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.tfContent.ad_name += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.tfContent.ad_name = this.tfContent.ad_name.replace("{" + item + "}", "");
      }
    },
    showMaterialModal() {
      this.$refs.materialModalRef.showModal();
    },
    showRecommendProductPoint(type) {
      this.$refs.productPointModalRef.showModal(type);
    },
    chooseProductRecommend(data, type) {
      data.map((item) => {
        if (type === "recommend") {
          if (!this.productInfo.selling_points.includes(item)) {
            this.productInfo.selling_points.push(item);
          }
        } else {
          if (!this.productInfo.call_to_action_buttons.includes(item)) {
            this.productInfo.call_to_action_buttons.push(item);
          }
        }
      });
    },
    // 引用已有广告
    showReferenceAlreadyAdModal() {
      this.$refs.referenceAlreadyAdModalRef.showModal();
    },
    selectedMaterial(resData) {
      let selectedData = resData.mapList;
      let selectObj = Object.values(selectedData);
      selectObj.map((item) => {
        const ids = this.productInfo.imageList.map((item) => item.toutiaoId);
        if (!ids.includes(item.toutiaoId)) {
          if (this.productInfo.imageList.length < 10) {
            this.productInfo.imageList.push(item);
          } else {
            this.$message.warning("产品主图最多为10张");
          }
        }
      });
    },
    deleteImage(imgInfo) {
      const index = this.productInfo.imageList.findIndex((item) => item.toutiaoId === imgInfo.toutiaoId);
      this.productInfo.imageList.splice(index, 1);
    },
    // 添加推广卖点
    addRecommend() {
      if (this.productInfo.selling_points.length > 9) {
        this.$message.warning("产品卖点最大长度为10个");
      }
      if (this.getStringLength(this.inputRecommed) < 6 || this.getStringLength(this.inputRecommed) > 9) {
        this.$message.warning("产品卖点应6-9个字符");
      } else {
        if (this.productInfo.selling_points.includes(this.inputRecommed)) {
          this.$message.warning("该产品卖点已经存在，无需重复添加");
        } else {
          this.productInfo.selling_points.push(this.inputRecommed);
          this.inputRecommed = "";
        }
      }
    },
    // 添加行动号召
    addCallAction() {
      if (this.productInfo.call_to_action_buttons.length > 9) {
        this.$message.warning("行动号召最大长度为10个");
      }
      if (this.getStringLength(this.inputCallAction) < 2 || this.getStringLength(this.inputCallAction) > 6) {
        this.$message.warning("行动号召应2-6个字符");
      } else {
        if (this.productInfo.call_to_action_buttons.includes(this.inputCallAction)) {
          this.$message.warning("该行动号召已经存在，无需重复添加");
        } else {
          this.productInfo.call_to_action_buttons.push(this.inputCallAction);
          this.inputCallAction = "";
        }
      }
    },
    clearSellPoints(type) {
      if (type === "recommend") {
        this.productInfo.selling_points = [];
      } else {
        this.productInfo.call_to_action_buttons = [];
      }
    },
    deletePoints(type, index) {
      if (type === "recommend") {
        this.productInfo.selling_points.splice(index, 1);
      } else {
        this.productInfo.call_to_action_buttons.splice(index, 1);
      }
    },
    // 选择产品
    chooseProduct() {
      this.$refs.relatedProductModalRef.showModal();
    },
    // 立即采纳出价系数
    handleAccept() {
      this.deliveryRange.search_bid_ratio = this.recommendBid;
    },
    chooseRelateProduct(data) {
      this.relatedProduct.productId = data.product_id;
      this.relatedProduct.productPlatformId = data.platformId;
      this.relatedProduct.productTableData = [data];
      this.relatedProduct.productSetting = "SINGLE";
      this.$refs.relatedProductRef.resetFields();
    },
    choosePromotion(data) {
      this.productInfo = data.productInfo;
      const { anchor_material_list, nativeSetting } = data;
      this.nativeSetting = {
        identityType: nativeSetting.aweme_id ? "TIKTOK" : "ACCOUNT",
        aweme_id: nativeSetting.aweme_id,
        anchor_related_type: nativeSetting.anchor_related_type,
        anchor_id: anchor_material_list[0]?.anchor_id,
      };
      this.tfContent.ad_name = data.promotionName;
      this.$refs.productInfoRef.clearValidate();
      this.$store.commit("set_budget_and_bid_ttV2", data.budgetBids);
      this.$store.commit("set_sitePage_ttV2", data.sitePage);
      this.$store.commit("set_title_group_ttV2", data.title_group);
      this.$refs.ldyRef.initOptions();
    },
    saveInStore() {
      //将表单数据转为接口用数据
      let data = JSON.parse(JSON.stringify(this.tfContent));
      data.app_type = this.app_type;
      data.deep_bid_type = data.deep_external_action === "NONE" ? null : data.deep_bid_type;
      data.ad_name = nameTransforUtil.showDataToApi(data.ad_name);
      const productInfo = JSON.parse(JSON.stringify(this.productInfo));
      productInfo.image_ids = productInfo.imageList?.map((item) => item.toutiaoId);
      // 原生锚点
      const originData = JSON.parse(JSON.stringify(this.nativeSetting));
      const anchorMaterial = {
        anchor_id: originData.identityType === "TIKTOK" && originData.anchor_related_type === "SELECT" ? originData.anchor_id : "",
      };
      // 推广身份
      const nativeSetting = {
        anchor_related_type: originData.anchor_related_type,
        aweme_id: originData.identityType === "TIKTOK" ? originData.aweme_id : "",
      };
      //是否开启搜索快投
      let deliveryRangeData = JSON.parse(JSON.stringify(this.deliveryRange));
      if (deliveryRangeData.searchToLaunch === 1) {
        deliveryRangeData.keywords = this.wordsList;
      }
      deliveryRangeData.search_bid_ratio = deliveryRangeData.search_bid_ratio || null;
      this.$store.commit("set_optimize_goal_ttV2", data);
      // 推广身份，原生锚点用于模板回显
      this.$store.commit("set_origin_native_data_ttV2", this.nativeSetting);
      this.$store.commit("set_anchor_material_ttV2", anchorMaterial);
      this.$store.commit("set_native_setting_ttV2", nativeSetting);
      this.$store.commit("set_product_info_ttV2", productInfo);
      this.$store.commit("set_related_product_ttV2", this.relatedProduct);
      this.$store.commit("set_deliveryRange_ttV2", deliveryRangeData);
    },
    //数据渲染
    renderData() {
      //投放内容
      if (this.optimizeGoal) {
        const storeVal = JSON.parse(JSON.stringify(this.optimizeGoal));
        this.tfContent = storeVal;
        //广告计划名称
        if (storeVal.ad_name) {
          this.tfContent.ad_name = nameTransforUtil.apiDatatoShow(storeVal.ad_name);
          this.selectItem = [];
          this.adGroupList.map((item, index) => {
            if (this.tfContent.ad_name.includes(`{${item}}`)) {
              this.selectItem.push(index);
            }
          });
        } else {
          this.tfContent.ad_name = "";
          this.selectItem = [];
        }
      }
      // 产品信息
      if (this.productInfoStore) {
        this.productInfo = this.productInfoStore;
      }
      if (this.originNativeSettingData) {
        this.nativeSetting = this.originNativeSettingData;
      }
      // 关联产品投放
      if (this.relatedProductStore) {
        this.relatedProduct = this.relatedProductStore;
      }
      //投放位置
      if (this.deliveryRangeStore) {
        let value = JSON.parse(JSON.stringify(this.deliveryRangeStore));
        this.deliveryRange.inventory_catalog = value.inventory_catalog || "UNIVERSAL_SMART";
        this.deliveryRange.union_video_type = value.union_video_type || "REWARDED_VIDEO";
        this.deliveryRange.inventory_type = value.inventory_type || [];
        this.deliveryRange.search_bid_ratio = value.search_bid_ratio;
        this.deliveryRange.audience_extend = value.audience_extend || "ON";
        //搜索快投是否打开
        if (value.keywords) {
          this.deliveryRange.searchToLaunch = 1;
          this.wordsList = value.keywords;
        } else {
          this.deliveryRange.searchToLaunch = 0;
          this.wordsList = [];
        }
      }
      //赋值包名
      if (this.checkedApp && this.checkedApp.package_name) {
        this.tfContent.package_name = this.checkedApp.package_name;
      }
    },
    //校验投放内容的数据格式
    checkCurData() {
      return Promise.all([
        //投放内容
        new Promise((resolve, reject) => {
          this.$refs.tfcontentRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
        //推广身份
        new Promise((resolve, reject) => {
          this.$refs.nativeSettingRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
        //  原生锚点
        new Promise((resolve, reject) => {
          if (!this.$refs.nativeAnchorRef) {
            resolve();
          } else {
            this.$refs.nativeAnchorRef?.validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          }
        }),
        //产品信息
        new Promise((resolve, reject) => {
          this.$refs.productInfoRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
        // 关联产品信息
        new Promise((resolve, reject) => {
          this.$refs.relatedProductRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
        //投放位置
        new Promise((resolve, reject) => {
          this.$refs.deliveryRangeRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
    selectOk(data) {
      data.wordList.forEach((key) => {
        if (this.wordsList.length < 1000) {
          this.wordsList.push({
            match_type: data.match_type,
            keyword: key,
          });
        }
      });
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.adGroupList.slice(0, 5);
      }
      return this.adGroupList;
    },
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      optimizeGoal: (state) => state.PromotionTtV2.optimizeGoal,
      productInfoStore: (state) => state.PromotionTtV2.productInfo,
      relatedProductStore: (state) => state.PromotionTtV2.relatedProduct,
      deliveryRangeStore: (state) => state.PromotionTtV2.deliveryRange,
      deliverySetting: (state) => state.PromotionTtV2.deliverySetting,
      alreadyProjectId: (state) => state.PromotionTtV2.baseData.projectId,
      originNativeSettingData: (state) => state.PromotionTtV2.originNativeSettingData,
      ad_name: (state) => state.PromotionTtV2.draft_adset.ad_name,
      app_type: (state) => {
        let type = state.PromotionTtV2.checkedApp.os_type;
        return type ? "APP_" + type : "";
      },
      app_pkg: (state) => {
        return state.PromotionTtV2.checkedApp.package_name || null;
      },
      checkedApp: (state) => state.PromotionTtV2.checkedApp,
      isCanAddRecommend() {
        return this.inputRecommed && this.getStringLength(this.inputRecommed) >= 6 && this.getStringLength(this.inputRecommed) <= 9;
      },
      isCanAddCallAction() {
        return this.inputCallAction && this.getStringLength(this.inputCallAction) >= 2 && this.getStringLength(this.inputCallAction) <= 6;
      },
    }),
  },
  watch: {
    "checkedApp.asset_id": {
      handler(val) {
        console.log(val, this.nativeSetting, this.originNativeSettingData.aweme_id);
        if (val) {
          this.nativeSetting.anchor_id = "";
          this.$store.commit("set_origin_native_data_ttV2", this.nativeSetting);
        }
      },
      // immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.edit-wrap {
  height: calc(100vh - 63px);
  box-sizing: border-box;
  background: rgba(228, 232, 239, 1);
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  overflow: auto;
  .item-card {
    background-color: #fff;
    padding: 24px;
    margin-bottom: 6px;
    .card-title {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
  }
  // .item-card:not(:last-child) {
  //   margin-bottom: 6px;
  // }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 4px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 0px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }
          .imgs-list {
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            background: #f4f4f4;
            padding: 10px 0px 0px 10px;
            .add-material {
              width: 104px;
              height: 104px;
              border-radius: 2px;
              border: 1px dashed rgba(0, 0, 0, 0.15);
              background-color: #fff;
              display: flex;
              margin-right: 13px;
              margin-bottom: 12px;
              .img-wrap {
                width: 100%;
                height: 100%;
                position: relative;
                .el-icon-close {
                  position: absolute;
                  cursor: pointer;
                  width: 12px;
                  height: 12px;
                  background: red;
                  border-radius: 50%;
                  padding: 4px;
                  top: -10px;
                  right: -8px;
                  font-size: 12px;
                  color: white;
                }
                .materialI-img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
            }
            .add-wrap {
              display: flex;
              width: 100%;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              color: rgba(0, 0, 0, 0.65);
              border: 1px dashed rgba(0, 0, 0, 0.15);
              width: 104px;
              height: 104px;
              margin-bottom: 12px;
              cursor: pointer;
              .add-icon {
                font-size: 25px;
                margin-bottom: 10px;
              }
              .add-text {
                font-size: 14px;
              }
            }
          }
          .md-wrap {
            .md-item {
              .view-recommend {
                cursor: pointer;
                color: #1890ff;
                margin-left: 8px;
                font-size: 14px;
              }
              .recommend-btn {
                background: #1890ff;
                color: white;
              }
              .recommend-btn-disabled {
                background: #a0cfff;
                color: white;
              }
              .point-list {
                width: 460px;
                border: 1px solid #dcdfe6;
                min-height: 100px;
                border-radius: 2px;
                margin-top: 12px;
                &-top {
                  width: 100%;
                  height: 40px;
                  border-bottom: 1px solid #dcdfe6;
                  display: flex;
                  line-height: 40px;
                  justify-content: space-between;
                  .clear-btn {
                    cursor: pointer;
                    color: #1890ff;
                    margin-right: 16px;
                  }
                }
                &-content {
                  padding: 0px 12px 0px 0px;
                  .point-item {
                    margin-left: 12px;
                  }
                  .el-tag {
                    font-size: 14px;
                  }
                }
                &-nodata {
                  color: #909399;
                  text-align: center;
                  line-height: 60px;
                }
              }
              .input-item {
                display: flex;
                align-items: center;
                .add-btn {
                  flex-shrink: 0;
                  width: 18px;
                  height: 18px;
                  text-align: center;
                  line-height: 18px;
                  margin-left: 5px;
                  cursor: pointer;
                  color: #fff;
                  border-radius: 2px;
                }
              }
            }
          }

          .name-list {
            padding: 12px 0px 0px 0px;
            margin: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .name-item {
              border-radius: 2px;
              border: 1px solid transparent;
              box-sizing: border-box;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.85);
              font-size: 12px;
              padding: 2px 6px;
              margin: 0 8px 8px 0px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                background: rgba(225, 240, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
            .show-more {
              color: rgba(24, 144, 255, 1);
              font-size: 13px;
              cursor: pointer;
              margin-left: 20px;
              line-height: 24px;
              i {
                margin-left: 4px;
              }
            }
          }
          .flow-table-wrap {
            margin-top: 12px;
            /deep/ th {
              height: 33px;
              padding: 2px 0;
            }
            /deep/ .el-table td,
            .el-table th {
              padding: 2px 0;
            }
            .header-wrap {
              display: flex;
              .transfor-manage {
                margin-left: auto;
                font-size: 12px;
                color: #409eff;
                cursor: pointer;
              }
            }
          }
          .search-wrap {
            margin-top: 12px;
            width: 400px;
            border: 1px solid #eee;
            border-radius: 4px;
            .top-header {
              height: 32px;
              background-color: #f5f6f7;
              border-bottom: 1px solid #eee;
            }
            .table-header {
              height: 32px;
              border-bottom: 1px solid #eee;
            }
            .table-content {
              min-height: 100px;
              max-height: 300px;
              overflow: auto;
              .table-row {
                .cell-right {
                  width: 120px;
                }
                &:hover {
                  background-color: #f5f6f7;
                }
              }
            }
            .cell-left {
              height: 100%;
              width: 258px;
              display: inline-block;
              line-height: 32px;
              font-size: 12px;
              padding: 0 10px;
              box-sizing: border-box;
            }
            .cell-right {
              height: 100%;
              width: 142px;
              display: inline-block;
              line-height: 32px;
              font-size: 12px;
              .btn-icon {
                color: #0b75ff;
                margin-right: 10px;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
.el-dropdown-menu {
  /deep/.my-dropdown-select {
    width: 200px;
    padding-left: 10px;
    .el-checkbox {
      display: block;
      line-height: 30px;
    }
    .el-radio {
      display: block;
      line-height: 26px;
      .el-radio__input.is-checked .el-radio__inner {
        color: rgba(24, 144, 255, 1);
        border-color: rgba(24, 144, 255, 1);
        background: rgba(24, 144, 255, 1);
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: rgba(24, 144, 255, 1);
      }
    }
    .my-dropdown-select-item {
      line-height: 30px;
      .img {
        height: 30px;
        width: 30px;
        position: relative;
        top: 10px;
        left: 3px;
      }
      .label {
        margin-left: 14px;
      }
    }
  }
}
</style>
